module.exports = __webpack_public_path__ + "img/logo-finerio.ea966ce6.svg";